import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus } from 'react-icons/fi'; // Using react-icons library
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for toast notifications
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { TreeSelect } from "antd";
import { FiX } from "react-icons/fi";

const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  color:#293495;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1; /* Ensure input takes up remaining space */
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000; /* Adjust color as needed */
`;

const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormItem = styled.div`
  min-width: 260px; /* Ensures a minimum width */
  flex: 1;
  margin-left:5px;
`;

const Label = styled.label`
  display: block;
  font-family: 'Segoe UI', 'Semibold';
  color: #000;
  margin-bottom: 5px;
  font-weight: 600;
   &::after {
    content: '*';
    color: red;
    margin-left: 5px;
  }
`;

const Asterisk = styled.span`
  color: red;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', 'Regular';
  margin-top:10px;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;
const TextArea = styled.textarea`
  width: 260px;
    padding: 0px 8px;
    border: none;
    border: 1px solid #2B3497;
    font-family: 'Segoe UI', 'Regular';
    background: transparent;
    resize: none;
    margin-top: -6px;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding:17px;
  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 20px;
  }
`;
const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;
  margin-right: 30px; // Space to the right of the button

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const SubmitButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  background-color: #2B3497; /* Dark blue */
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
`;

const ResetButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  background-color: #FF4B4B; /* Red */
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
`;

const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
       cursor: pointer;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;

const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;

const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;

const StyledTreeSelect = styled(TreeSelect)`
  width: 277px;
  min-width: 260px;
  border: none;
  border-bottom: 1px solid #2B3497;
  border-radius: 0;
  background: transparent;
    font-family: 'Segoe UI', 'Regular';


  .ant-select-selector {
    border: none;
    border-bottom: 1px solid #2B3497;
    border-radius: 0;
    padding: 5px 0;
    box-shadow: none !important;
    min-height: 36px;
    height: auto;
    max-height: 100px; /* Restricts height and enables vertical scrolling */
    display: flex;
    flex-wrap: wrap; /* Allows multiple rows */
    overflow-y: auto !important; /* Enables vertical scrolling */
  }

  /* Selected items container */
  .ant-select-selection-overflow {
    display: flex;
    flex-wrap: wrap !important; /* Enables multiple rows */
    overflow-y: auto !important; /* Enables vertical scrolling */
    max-height: 100px; /* Restricts height */
    align-items: center;
  }

  /* Selected item styling */
  .ant-select-selection-item {
    background-color: #f0f0f0;
    border-radius: 4px;
    padding: 2px 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px; /* Limits width of each selected item */
    font-size: 14px;
    margin: 2px;
  }

  /* Prevents the input from expanding indefinitely */
  .ant-select-selection-placeholder {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Dropdown styling */
  .ant-select-dropdown {
    width: 300px !important;
    max-height: 300px;
    overflow-y: auto;
  }

  /* Enable vertical scrollbar */
  .ant-select-selection-overflow::-webkit-scrollbar {
    width: 4px;
  }

  .ant-select-selection-overflow::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 2px;
  }

  .ant-select-selection-overflow::-webkit-scrollbar-track {
    background: transparent;
  }
`;




const VisitorTypeMapPage = () => {
  const [formValues, setFormValues] = useState({
    visitorType: '',
    checkinInstruction: ''
  });

  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showPagination, setShowPagination] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 7;
  const [showInput, setShowInput] = useState(false);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  const [treeData, setTreeData] = useState([]);
  const [processedTreeData, setProcessedTreeData] = useState([]);


  // Fetch Visitor type data from API
  useEffect(() => {
    const fetchEmployeeRoleMapData = async () => {
      try {
        const response = await axios.get('/VisitorType');
        setTableData(response.data);
      } catch (error) {
        console.error('Error fetching visitor type data:', error);
      }
      try {
        const responseVisi = await axios.get('/VisitorType/GetVisitorTypeDropdown');
        console.log("responseVisi", responseVisi);
        const rawTreeData = responseVisi.data;

        // Extract default mandatory values
        const defaultMandatoryValues = rawTreeData.flatMap(screen =>
          screen.children
            .filter(child => child.isdefaultmandatory)
            .map(child => child.value)
        );

        // Add 'disabled: true' to mandatory fields
        const updatedTreeData = rawTreeData.map(screen => ({
          ...screen,
          children: screen.children.map(child => ({
            ...child,
            disabled: child.isdefaultmandatory
          }))
        }));

        setTreeData(rawTreeData); // if you still need raw data elsewhere
        setProcessedTreeData(updatedTreeData);
        setSelectedValues(defaultMandatoryValues);
      } catch (error) {
        console.error('Error fetching visitor type data:', error);
      }
    };

    fetchEmployeeRoleMapData();
  }, []); // Empty dependency array means this useEffect runs once when the component mounts
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(tableData, column, direction);
    setTableData(sortedData);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const handleInputChangeUpdate = (e) => {
    const { name, value } = e.target;
    setFormValuesUpdate((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const [isPopupVisibleCreate, setIsPopupVisibleCreate] = useState(false);

  const handleAddLocationClick = () => {
    setIsPopupVisibleCreate(true);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSubmit = async () => {

    if (formValues.visitorType && formValues.checkinInstruction) {
      if (selectedValues.length === 0) {
        toast.error("Please select the appointment type");
        return; // Prevent submission
      }
      try {
        // Send formValues to API endpoint
        const response = await axios.post('/VisitorType', { visitorTypeDesc: formValues.visitorType, checkinInstruction: formValues.checkinInstruction, screen_Field_Def: generateScreenFieldDef() });
        // Check if the response indicates the visitor type already exists
        if (response.data === "Visitor type already exists") {
          handleReset();
          toast.error("Visitor Type already Exists");
        } else {


          console.log('Visitor type added successfully:', response.data);

          // Refetch the updated table data from the API
          const updatedData = await axios.get('/VisitorType');
          setTableData(updatedData.data);
          setIsPopupVisibleCreate(false)

          // Reset form state
          setFormValues({
            visitorType: '',
            checkinInstruction: ''
          });
          handleReset();

          // Show pagination after submitting at least one row
          setShowPagination(true);
          // Show success toast message
          toast.success("Visitor Type added successfully");

        }
      } catch (error) {
        console.error('Error adding visitor type:', error);
        // Handle error state or UI updates
        toast.error('Error adding visitor type');
      }
    }
    else {
      toast.error('please fill the all fields');

    }
  };


  const handleDelete = (id) => {
    confirmAlert({
      title: <span style={{ color: '#dc3545' }}>Warning</span>,
      message: 'Are you sure you want to delete this visitor type?',
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              // Sending the PUT request to mark the visitor type as deleted
              await axios.put('/VisitorType', {
                id: id,
                visitorTypeDesc: tableData.find(item => item.id === id)?.visitorTypeDesc,
                isDeleted: true
              });

              // Update the local state to remove the deleted visitor type from the UI
              setTableData((prevData) => prevData.filter(item => item.id !== id));

              // Show success toast message
              toast.success('Visitor Type Deleted Successfully');
            } catch (error) {
              console.error('Error deleting visitor type:', error);
              // Show error toast message
              toast.error('Failed to Delete Visitor Type');
            }
          }
        },
        {
          label: 'No',
          onClick: () => {
            // Close the dialog without action
          }
        }
      ]
    });
  };


  const handleReset = async () => {
    try {
      const responseVisi = await axios.get('/VisitorType/GetVisitorTypeDropdown');
      console.log("responseVisi", responseVisi);
      const rawTreeData = responseVisi.data;

      // Extract default mandatory values
      const defaultMandatoryValues = rawTreeData.flatMap(screen =>
        screen.children
          .filter(child => child.isdefaultmandatory)
          .map(child => child.value)
      );

      // Add 'disabled: true' to mandatory fields
      const updatedTreeData = rawTreeData.map(screen => ({
        ...screen,
        children: screen.children.map(child => ({
          ...child,
          disabled: child.isdefaultmandatory
        }))
      }));

      setTreeData(rawTreeData); // if you still need raw data elsewhere
      setProcessedTreeData(updatedTreeData);
      setSelectedValues(defaultMandatoryValues);
    } catch (error) {
      console.error('Error fetching visitor type data:', error);
    }
    setFormValues({
      visitorType: '',
      checkinInstruction: ''
    });
    setCurrentPage(1); // Reset pagination to the first page
  };



  const filteredData = tableData.filter((row) =>
    row.visitorTypeDesc && row.visitorTypeDesc.toLowerCase().includes(searchQuery.toLowerCase())
  );
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );


  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState('');

  const [selectedValuesUpdate, setSelectedValuesUpdate] = useState([]);


  const handleChangeUpdate = (value) => {
    setSelectedValuesUpdate(value); // Don't merge here
    console.log("value", value);


  };
  useEffect(() => {
    console.log("processedTreeData", processedTreeData);
  }, [processedTreeData]);

  const handleEdit = async (row) => {
    try {
      const responseVisi = await axios.get('/VisitorType/GetVisitorTypeDropdown');
      const rawTreeData = responseVisi.data;

      // Get default mandatory values
      const defaultMandatoryValues = rawTreeData.flatMap(screen =>
        screen.children
          .filter(child => child.isdefaultmandatory)
          .map(child => child.value)
      );

      // Disable default mandatory fields
      const updatedTreeData = rawTreeData.map(screen => ({
        ...screen,
        children: screen.children.map(child => ({
          ...child,
          disabled: child.isdefaultmandatory
        }))
      }));

      // Set updated data
      setTreeData(rawTreeData);
      setProcessedTreeData(updatedTreeData);

      // Default selected (pre-selected) values
      let checkedValues = [...defaultMandatoryValues];
      let backendMandatoryFields = [];

      const preloadedData = row.screen_Field_Def;

      // Handle case when backend returns additional mandatory fields
      if (preloadedData && preloadedData.length > 0) {
        backendMandatoryFields = preloadedData.flatMap(item =>
          item.input_Fields
            .filter(field => field.is_Mandatory)
            .map(field => field.field_Name)
        );

        checkedValues = Array.from(new Set([...defaultMandatoryValues, ...backendMandatoryFields]));
      }

      setMandatorySelected(backendMandatoryFields);
      setSelectedValuesUpdate(checkedValues);

      setFormValuesUpdate({
        visitorTypeUpdate: row.visitorTypeDesc,
        checkinInstructionUpdate: row.checkinInstruction || '',
      });

      setPopupData(row);
      setIsPopupVisible(true);
    } catch (error) {
      console.error('Error fetching visitor type data:', error);
    }
  };

  const closePopup = () => {
    setErrors({
      visitorTypeUpdate: false,
      checkinInstructionUpdate: false
    })

    setIsPopupVisible(false);

  };
  const [formValuesUpdate, setFormValuesUpdate] = useState({
    visitorTypeUpdate: '',
    checkinInstructionUpdate: ''
  });
  const [errors, setErrors] = useState({
    visitorTypeUpdate: false,
    checkinInstructionUpdate: false
  })
  const [mandatorySelected, setMandatorySelected] = useState([]);

  const handleSubmitUpdate = async () => {
    const newErrors = {
      visitorTypeUpdate: !formValuesUpdate.visitorTypeUpdate.trim(),
      checkinInstructionUpdate: !formValuesUpdate.checkinInstructionUpdate.trim()
    };

    setErrors(newErrors);

    if (formValuesUpdate.visitorTypeUpdate && formValuesUpdate.checkinInstructionUpdate) {

      try {
        // Send formValues to API endpoint
        const response = await axios.put('/VisitorType', { visitorTypeDesc: formValuesUpdate.visitorTypeUpdate, checkinInstruction: formValuesUpdate.checkinInstructionUpdate, id: popupData.id, screen_Field_Def: generateScreenFieldDefUpdate() });
        // Check if the response indicates the visitor type already exists
        if (response.data === "Visitor type already exists") {
          toast.error("Visitor Type already Exists");
        } else {


          console.log('Visitor type added successfully:', response.data);

          // Refetch the updated table data from the API
          const updatedData = await axios.get('/VisitorType');
          setTableData(updatedData.data);

          // Reset form state
          setFormValuesUpdate({
            visitorTypeUpdate: '',
            checkinInstructionUpdate: ''
          });
          closePopup();

          // Show pagination after submitting at least one row
          setShowPagination(true);
          // Show success toast message
          toast.success("Visitor Type updated successfully");
        }
      } catch (error) {
        console.error('Error adding visitor type:', error);
        // Handle error state or UI updates
        toast.error('Error adding visitor type');
      }
    }
    else {

      toast.error('please fill the mandatory fields');

    }
  };
  const [selectedValues, setSelectedValues] = useState([]);

  const handleChange = (value) => {
    const mandatoryValues = processedTreeData.flatMap(screen =>
      screen.children
        .filter(child => child.isdefaultmandatory)
        .map(child => child.value)
    );

    let allSelected = [];

    value.forEach(val => {
      // Check if val is a parent node (screen value)
      const matchedScreen = processedTreeData.find(screen => screen.value === val);
      if (matchedScreen) {
        // If parent is selected, add all children
        allSelected.push(...matchedScreen.children.map(child => child.value));
      } else {
        // Else it's a child, add directly
        allSelected.push(val);
      }
    });

    // Ensure mandatory fields are always included
    const uniqueValues = Array.from(new Set([...mandatoryValues, ...allSelected]));

    setSelectedValues(uniqueValues);
    console.log("✅ Updated selected values:", uniqueValues);
  };


  const generateScreenFieldDef = () => {
    const screenFieldDef = [];

    processedTreeData.forEach(screen => {
      const matchedFields = screen.children.filter(child =>
        selectedValues.includes(child.value)
      );

      if (matchedFields.length > 0) {
        screenFieldDef.push({
          screen_Id: screen.value,
          input_Fields: matchedFields.map(child => ({
            field_Name: child.value,
            is_Mandatory: true
          }))
        });
      }
    });

    return screenFieldDef;
  };



  const generateScreenFieldDefUpdate = () => {
    // Only keep mandatory fields that are still selected
    const merged = Array.from(new Set([
      ...selectedValuesUpdate.filter(value => mandatorySelected.includes(value)),
      ...selectedValuesUpdate
    ]));

    const screenFieldDef = [];

    processedTreeData.forEach(screen => {
      const matchedFields = screen.children?.filter(child =>
        merged.includes(child.value)
      );

      if (matchedFields && matchedFields.length > 0) {
        screenFieldDef.push({
          screen_Id: screen.value,
          input_Fields: matchedFields.map(field => ({
            field_Name: field.value,
            is_Mandatory: true,
          })),
        });
      }
    });

    return screenFieldDef;
  };
  const updatedTreeData = processedTreeData.map((item) => ({
    ...item,
    disabled: item.isdefaultmandatory === true
  }));




  return (
    <Container>
      <Header>
        <Heading>Visitor Type </Heading>
        <SearchBox>
          <SearchIcon size={20} />
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </SearchBox>
      </Header>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
          <Button className="add-location" onClick={handleAddLocationClick}>
            Add Visitor Type<FiPlus size={20} />
          </Button>
          {/* {showInput && (
            <FormGroup>
              <FormItem>
                <Label>
                  Visitor Type<Asterisk>*</Asterisk>
                </Label>
                <Input
                  type="text"
                  name="visitorType"
                  value={formValues.visitorType}
                  onChange={handleInputChange}
                  placeholder="Enter visitor type"
                />
              </FormItem>
            </FormGroup>
          )}

          {showInput && (
            <FormGroup>
              <FormItem>
                <Label>
                  Check-In Instructions<Asterisk>*</Asterisk>
                </Label>
                <TextArea

                  name="checkinInstruction"
                  value={formValues.checkinInstruction}
                  onChange={handleInputChange}
                  placeholder="Enter Instructions"
                  rows="3" // You can adjust the number of rows as needed
                />
              </FormItem>
            </FormGroup>
          )}
          {showInput && (
            <FormGroup>
              <FormItem>
                <Label>
                  Appointment Type <Asterisk>*</Asterisk>
                </Label>
                <StyledTreeSelect
                  treeData={processedTreeData}
                  value={selectedValues}
                  onChange={handleChange}
                  treeCheckable={true}
                  showCheckedStrategy={TreeSelect.SHOW_PARENT}
                  placeholder="Select Appointment Type"

                />

              </FormItem>
            </FormGroup>


          )} */}
        </div>
        {/* <ButtonGroup>
          <ResetButton onClick={handleReset}>Reset</ResetButton>
          <SubmitButton onClick={handleSubmit}>Add Visitor Type</SubmitButton>
        </ButtonGroup> */}

      </Card>
      {filteredData.length === 0 ? (
        <ZeroStateMessage>No data available</ZeroStateMessage>
      ) : (
        <TableContainer>
          <StyledTable>
            <thead>
              <tr>
                <TableHeader colSpan={'2'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>Visitor Type Details</span>
                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                      {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                    </IconWrapper>
                  </div>
                </TableHeader>

              </tr>
            </thead>
            {isExpanded && (
              <>
                <thead>
                  <tr>
                    <TableHeader onClick={() => handleSort('visitorTypeDesc')}>Visitor Type{sortColumn === 'visitorTypeDesc' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader>Actions</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.visitorTypeDesc}</TableCell>
                      <TableCell>
                        <IconWrapper onClick={() => handleEdit(row)}>
                          <FiEdit />
                        </IconWrapper>
                        <IconWrapper onClick={() => handleDelete(row.id)}>
                          <FiTrash2 />
                        </IconWrapper>
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </>
            )}
          </StyledTable>
          {isExpanded && (
            <>
              <PaginationContainer>
                <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                  Previous
                </PaginationButton>

                <DropdownSelect value={currentPage} onChange={handlePageChange}>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Page {i + 1}
                    </option>
                  ))}
                </DropdownSelect>

                <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                  Next
                </PaginationButton>
              </PaginationContainer>
            </>
          )}

          {isPopupVisibleCreate && (
            <Popup>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0, color: '#293495' }}>Add Visitor Type</h3>
                <FiX
                  style={{ cursor: 'pointer' }}
                  size={20}
                  onClick={() => setIsPopupVisibleCreate(false)}
                />
              </div>
              <LabelValueContainer>
                <Label>Visitor Type:</Label>
                <Value>
                  <Input
                    type="text"
                    name="visitorType"
                    value={formValues.visitorType}
                    onChange={handleInputChange}
                    placeholder="Enter visitor type"
                  />
                </Value>
              </LabelValueContainer>

              <LabelValueContainer>
                <Label>Check-In Instruction:</Label>
                <Value><TextArea
                  name="checkinInstruction"
                  value={formValues.checkinInstruction}
                  onChange={handleInputChange}
                  placeholder="Enter Instructions"
                  rows="3" // You can adjust the number of rows as needed
                /></Value>
              </LabelValueContainer>
              <LabelValueContainer>
                <Label>Select Appointment Type:</Label>
                <Value><StyledTreeSelect
                  treeData={processedTreeData}
                  value={selectedValues}
                  onChange={handleChange}
                  treeCheckable={true}
                  showCheckedStrategy={TreeSelect.SHOW_PARENT}
                  placeholder="Select Appointment Type"

                />
                </Value>
              </LabelValueContainer>



              <ButtonContainer>
                <PopupButton onClick={handleReset} style={{ backgroundColor: 'red' }}>Reset</PopupButton>
                <PopupButton onClick={handleSubmit}>Submit</PopupButton>
              </ButtonContainer>
              {/* Show loader when loading */}
            </Popup>
          )}
          {isPopupVisible && (
            <Popup>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ margin: 0, color: '#293495' }}> Visitor Type</h3>
                <FiX
                  style={{ cursor: 'pointer' }}
                  size={20}
                  onClick={() => {
                    setErrors({
                      visitorTypeUpdate: false,
                      checkinInstructionUpdate: false
                    })
                    setIsPopupVisible(false)
                  }
                  }
                />
              </div>
              <LabelValueContainer>
                <Label>Visitor Type:</Label>
                <Value><Input
                  type="text"
                  name="visitorTypeUpdate"
                  value={formValuesUpdate.visitorTypeUpdate}
                  onChange={handleInputChangeUpdate}
                  placeholder="Enter visitor type"
                  style={{
                    border: errors.visitorTypeUpdate ? '1px solid red' : ''
                  }}
                /></Value>
              </LabelValueContainer>

              <LabelValueContainer>
                <Label>Check-In Instruction:</Label>
                <Value><TextArea
                  name="checkinInstructionUpdate"
                  value={formValuesUpdate.checkinInstructionUpdate}
                  onChange={handleInputChangeUpdate}
                  placeholder="Enter Instructions"
                  rows="3" // You can adjust the number of rows as needed
                  style={{
                    border: errors.checkinInstructionUpdate ? '1px solid red' : ''
                  }}
                /></Value>
              </LabelValueContainer>
              <LabelValueContainer>
                <Label>Appointment Type:</Label>
                <Value><StyledTreeSelect
                  treeData={updatedTreeData}
                  value={selectedValuesUpdate}
                  onChange={handleChangeUpdate}
                  treeCheckable={true}
                  showCheckedStrategy={TreeSelect.SHOW_ALL}
                  placeholder="Select Appointment Type"
                />
                </Value>
              </LabelValueContainer>



              <ButtonContainer>
                <PopupButton onClick={closePopup} style={{ backgroundColor: 'red' }}>Close</PopupButton>
                <PopupButton onClick={handleSubmitUpdate}>Update</PopupButton>
              </ButtonContainer>
              {/* Show loader when loading */}
            </Popup>
          )}
        </TableContainer>
      )}
      <ToastContainer />

    </Container>
  );
};

export default VisitorTypeMapPage;
